import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PriceType } from "models";
import { boService } from "services";
import { RootState } from "store";
import { Loading, QueryParams } from "types";

const name = "bo";
interface ProductState {
  priceTypes: PriceType[];
  priceTypesLoading: Loading;
}

const initialState: ProductState = {
  priceTypes: [],
  priceTypesLoading: "idle",
};

export const fetchPriceTypes = createAsyncThunk(
  `${name}/list-management-qbo-price-types`,
  async (payload: QueryParams, { rejectWithValue, getState }) => {
    try {
      const response = await boService.getQBOPriceTypes();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const boSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPriceTypes.pending, (state) => {
        state.priceTypesLoading = "pending";
      })
      .addCase(fetchPriceTypes.fulfilled, (state, action) => {
        state.priceTypesLoading = "idle";
        state.priceTypes = action.payload.data ?? [];
      })
      .addCase(fetchPriceTypes.rejected, (state) => {
        state.priceTypesLoading = "idle";
      });
  },
});

export const selectPriceTypes = (state: RootState) => state.bo.priceTypes;
export const selectPriceTypesLoading = (state: RootState) =>
  state.bo.priceTypesLoading;

export default boSlice.reducer;
